// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_My_","cls2":"NewsInteractionBar-cls2_D5P NewsInteractionBar-cls1_My_"};